"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploaderInput = UploaderInput;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Icons = require("../components/Icons");
var _core = require("@focaltec-suite/core");
var _Progress = require("./Progress");
var _validators2 = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function UploaderInput(config) {
  var _a;
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var s3Client = config.s3Client;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)({
      valid: true,
      blurer: setBlured
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    validation = _useState4[0],
    setValidation = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(config.value || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    uploading = _useState10[0],
    setUploading = _useState10[1];
  var fileInput = (0, _react.useRef)(null);
  var inputBlured = function inputBlured(_event) {
    if (!blured) {
      setBlured(true);
    }
  };
  (0, _react.useEffect)(function () {
    validate(config.value || '');
    // eslint-disable-next-line
  }, [config.required, config.disabled]);
  var openFile = function openFile() {
    fileInput.current.click();
  };
  var handleUpload = function handleUpload(event) {
    if (!event.target.files) {
      return;
    }
    var file = event.target.files[0];
    var newFileName = s3Client.fixKey(config.path || config.id, file);
    setUploading(true);
    s3Client.upload(newFileName, file, {
      access: access
    }).then(function (data) {
      var _a;
      validate((_a = data.location) !== null && _a !== void 0 ? _a : newFileName);
    })["catch"](function (err) {
      setError(err.message);
    })["finally"](function () {
      setUploading(false);
      fileInput.current.value = '';
    });
  };
  var validate = function validate(targetValue) {
    var inptValue = '';
    if (targetValue) {
      var values = targetValue.split('/');
      inptValue = values[values.length - 1];
    }
    setValue(inptValue);
    var validators = [];
    if (config.required) {
      validators.push(_validators2.TEXT_REQUIRED_VALIDATOR);
    }
    var valid = true,
      message = '';
    for (var _i = 0, _validators = validators; _i < _validators.length; _i++) {
      var validator = _validators[_i];
      if (!validator.isValid(targetValue)) {
        valid = false;
        message = validator.getMessage();
        break;
      }
    }
    validation.valid = valid;
    setValidation(validation);
    setError(message);
    if (typeof config.onValueChanged === 'function') {
      config.onValueChanged(config.name, targetValue, validation);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    spacing: 0
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    id: config.id,
    value: value,
    label: config.label,
    variant: config.variant || 'outlined',
    margin: "dense",
    size: (_a = config.size) !== null && _a !== void 0 ? _a : 'small',
    required: config.required,
    disabled: config.disabled || config.readOnly,
    error: blured && !validation.valid,
    helperText: blured ? error : '',
    onClick: openFile,
    fullWidth: true,
    onChange: handleUpload,
    InputProps: {
      readOnly: config.readOnly || false,
      startAdornment: config.startAdornment,
      endAdornment: config.readOnly ? undefined : (/*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        edge: "end",
        size: "medium",
        disabled: uploading
      }, uploading && /*#__PURE__*/_react["default"].createElement(_Progress.Progress, null), !uploading && config.tooltip && (/*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: config.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_Icons.AttachIcon, {
        fontSize: "medium"
      }))), !uploading && !config.tooltip && (/*#__PURE__*/_react["default"].createElement(_Icons.AttachIcon, {
        fontSize: "medium"
      })))))
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    disabled: config.disabled || config.readOnly,
    onChange: handleUpload,
    ref: fileInput,
    accept: config.acceptExtension,
    onBlur: inputBlured,
    required: config.required,
    style: {
      display: 'none'
    }
  })), config.value && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: config.value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement("small", null, (0, _core.translate)('buttons.view_document'))))));
}